import { Tooltip } from "@mui/material";
import { FC } from "react";
import { useDialog } from "../../../hooks/UseDialog";
import { DeleteIcon } from "../../../assets/icons/Icons";
import ConfirmDeleteDialog from "./ConfirmDeleteDialog";
import { useTranslation } from "react-i18next";
import { GeneralButton } from "../../../common/ui/GeneralButton";

interface DeleteBtnProps {
  isCreateNewMode?: boolean;
  dialogMessage: string;
  isDisabled?: boolean;
  handleOnDelete: () => void;
  hoverText?: string;
}

const DeleteBtn: FC<DeleteBtnProps> = ({
  handleOnDelete,
  isCreateNewMode,
  dialogMessage,
  isDisabled = false,
  hoverText,
}) => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();
  const { t } = useTranslation();

  return (
    <>
      <Tooltip title={hoverText ? hoverText : t("buttons.delete")}>
        <GeneralButton
          appVariant="dangerIcon"
          disabled={isDisabled}
          onClick={isCreateNewMode ? handleOnDelete : handleDialogOpen}
        >
          <DeleteIcon />
        </GeneralButton>
      </Tooltip>
      {!isCreateNewMode && (
        <ConfirmDeleteDialog
          open={open}
          dialogMessage={dialogMessage}
          handleOnDelete={handleOnDelete}
          handleDialogClose={handleDialogClose}
        />
      )}
    </>
  );
};

export default DeleteBtn;
